import { useTranslation } from 'react-i18next';

import { getImageUrl } from '@/utils/dedaloUtils';
import { useImageDimensions } from '@/hooks/useImageDimensions';
import { usePhotoSwipeLightbox } from '@/hooks/usePhotoSwipeLightbox';

function Photos({ images }) {
    const { t } = useTranslation();
    const dims = useImageDimensions(images);
    usePhotoSwipeLightbox('gallery');

    return (
        <div className="has-background-light p-7 radius flow">
            <h3>{t('fotografias')}</h3>
            <div className="py-5">
                <ul className="photos-gallery list-reset pswp-gallery" id="gallery">
                    {images &&
                        images.length > 0 &&
                        images.map((item, i) => (
                            <li key={'photos-' + i}>
                                <a
                                    href={getImageUrl(item.image)}
                                    data-pswp-width={dims[item.image]?.width}
                                    data-pswp-height={dims[item.image]?.height}
                                    rel="noreferrer"
                                >
                                    <span className="hidden-caption-content">{item.footprint}</span>
                                    <img
                                        src={getImageUrl(item.image)}
                                        alt={item.footprint || ''}
                                        className="radius"
                                    />
                                </a>
                            </li>
                        ))}
                </ul>
            </div>
        </div>
    );
}

export default Photos;
